import EventEmitter from 'events'

export const protocol = {
  PAYMENT_STATUS_UPDATE: 'PAYMENT_STATUS_UPDATE',
}

/* eslint-disable no-underscore-dangle */
export class ClientEventHandler extends EventEmitter {
  static _instance = null

  static get instance() {
    if (!ClientEventHandler._instance) {
      ClientEventHandler._instance = new ClientEventHandler()
    }
    return ClientEventHandler._instance
  }

  emit(key, ...args) {
    if (process.env.NODE_ENV === 'development') {
      console.log(key, ...args)
    }
    return super.emit(key, ...args)
  }
}

export default ClientEventHandler.instance
